export default function NewMessage({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="w-[154px] p-2 bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor rounded-md flex flex-row items-center justify-center space-x-2 hover:bg-SeabiscuitMainThemeColor hover:text-white"
    >
      New Message
    </button>
  )
}
